var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_483_31630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    transform: "translate(0.266602 0.158203)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 24.3549C19.0467 24.3549 24.4633 18.9383 24.4633 12.2566C24.4633 5.57482 19.0467 0.158203 12.365 0.158203C5.68322 0.158203 0.266602 5.57482 0.266602 12.2566C0.266602 18.9383 5.68322 24.3549 12.365 24.3549Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8389 12.2577H24.4632C24.4632 11.1657 24.3177 10.1079 24.0464 9.10156H11.8389V12.2577Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8389 5.94517H22.6875C21.9469 4.73666 21 3.66846 19.8959 2.78906H11.8389V5.94517Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.365 24.3547C15.2123 24.3547 17.8294 23.3706 19.896 21.7246H4.83398C6.90063 23.3706 9.5177 24.3547 12.365 24.3547Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04229 18.5702H22.6876C23.2821 17.6 23.7432 16.5395 24.0465 15.4141H0.68335C0.986612 16.5395 1.44772 17.6 2.04229 18.5702Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87078 2.04753H6.97329L5.94777 2.79257L6.3395 3.99811L5.31402 3.25306L4.28855 3.99811L4.62692 2.95666C3.72399 3.70879 2.93259 4.58998 2.28041 5.57184H2.63367L1.98088 6.04608C1.87918 6.21574 1.78164 6.3881 1.68816 6.563L1.99988 7.52241L1.41831 7.09987C1.27374 7.40615 1.14151 7.71934 1.02265 8.03905L1.36609 9.09614H2.63367L1.60815 9.84118L1.99988 11.0467L0.974402 10.3017L0.360127 10.748C0.298643 11.2422 0.266602 11.7456 0.266602 12.2566H12.365C12.365 5.57486 12.365 4.78715 12.365 0.158203C9.97496 0.158203 7.74702 0.851495 5.87078 2.04753ZM6.3395 11.0467L5.31402 10.3017L4.28855 11.0467L4.68028 9.84118L3.65475 9.09614H4.92234L5.31402 7.89061L5.70571 9.09614H6.97329L5.94777 9.84118L6.3395 11.0467ZM5.94777 6.31688L6.3395 7.52241L5.31402 6.77737L4.28855 7.52241L4.68028 6.31688L3.65475 5.57184H4.92234L5.31402 4.3663L5.70571 5.57184H6.97329L5.94777 6.31688ZM10.6791 11.0467L9.65364 10.3017L8.62817 11.0467L9.0199 9.84118L7.99437 9.09614H9.26196L9.65364 7.89061L10.0453 9.09614H11.3129L10.2874 9.84118L10.6791 11.0467ZM10.2874 6.31688L10.6791 7.52241L9.65364 6.77737L8.62817 7.52241L9.0199 6.31688L7.99437 5.57184H9.26196L9.65364 4.3663L10.0453 5.57184H11.3129L10.2874 6.31688ZM10.2874 2.79257L10.6791 3.99811L9.65364 3.25306L8.62817 3.99811L9.0199 2.79257L7.99437 2.04753H9.26196L9.65364 0.841996L10.0453 2.04753H11.3129L10.2874 2.79257Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_483_31630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1967,
    height: 24.1967,
    fill: "white",
    transform: "translate(0.266602 0.158203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/Usa.4a8144e859971b738aaa9e305bc9cbde.svg";
export { ForwardRef as ReactComponent };